export const ExpandIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      fill="#0D1011"
      fillRule="evenodd"
      d="M8.667 2.5a.5.5 0 0 1 .5-.5h3.666C13.478 2 14 2.522 14 3.167v3.666a.5.5 0 0 1-1 0V3.707L9.687 7.02a.5.5 0 0 1-.707-.707L12.293 3H9.167a.5.5 0 0 1-.5-.5M2.5 8.667a.5.5 0 0 1 .5.5v3.126L6.313 8.98a.5.5 0 0 1 .707.707L3.707 13h3.126a.5.5 0 0 1 0 1H3.167A1.167 1.167 0 0 1 2 12.833V9.167a.5.5 0 0 1 .5-.5"
      clipRule="evenodd"
    />
  </svg>
);
